import { FormSubmitSuccess } from '../types/events/form-submit-success';
import { substituteFormName } from './form-interaction';

export const createFormSubmitSuccessEvent = (
  formName: string,
): FormSubmitSuccess => {
  return {
    event_name: 'form-submit-success',
    form_name: substituteFormName(formName),
  };
};
